export default function useForm(
  initialValues,
  validate = undefined,
  validateOnChange = false,
  disabledFields = undefined,
  values,
  setValues = undefined,
  errors,
  setErrors = undefined
) {

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
    if (validateOnChange) validate({ [name]: value });
  };

  const resetForm = () => {
    const keysInitialValues = Object.keys(initialValues);
    const fieldsToReset = {};
    Object.entries(values).forEach(([key, value]) => {
      let resetValue = true;
      if (disabledFields) {
        const field = disabledFields.filter((e) => e.field === key)?.[0];
        if (field) {
          resetValue = field.disabledFn ? !field.disabledFn(values) : false;
        }
      } else resetValue = keysInitialValues.includes(key);
      if (resetValue) {
        fieldsToReset[key] = "";
      } else fieldsToReset[key] = value;
    });
    setValues(fieldsToReset);
    setErrors({});
  };

  return {
    errors,
    setErrors,
    handleInputChange,
    resetForm,
  };
}
